import Vue from 'vue';
import { Mixin } from 'vue-mixin-decorator';

@Mixin
class ClickOutside extends Vue {
  protected clickOutside(callback: any, nameClass: string) {
    document.addEventListener('click', ( (event: any) => {
      const targetParent = event.target.offsetParent;
      if ( targetParent && targetParent.className ) {
        const isClickInside = String(targetParent.className).includes(nameClass);
        if (!isClickInside) {
          callback();
        }
      } else {
        callback();
      }
    }));
  }
}

export default ClickOutside;
